/* src/app/features/renuncia/renuncia-limite-adicional/listagem/listagem.component.scss */
#col-acoes {
  width: 8%;
}
.acoes a {
  opacity: 0;
  transition: opacity 0.15s ease-in-out;
}
tbody tr:hover .acoes a,
.acoes a:focus {
  opacity: 1;
}
/*# sourceMappingURL=listagem.component.css.map */
